import {Component} from '@angular/core';
import {GgAuthService} from '../../services/gg-auth.service';

@Component({
    selector: 'app-gg-login-page',
    templateUrl: './gg-login-page.component.html',
    styleUrl: './gg-login-page.component.scss'
})
export class AppGgLoginPageComponent {
    constructor(
        public ggAuthService: GgAuthService
    ) {
    }
}
